import React, { useState } from "react"
import { useForm, SubmitHandler } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { generateYupSchema } from "../../utility/buildSchema"
import { CustomRow } from "../../../../ui/spacings"
import { ContactFormProps } from "../../types"
import ContactFormFieldWrapper from "../ContactFormFieldWrapper"
import ContactFormFieldSwitcher from "../ContactFormFieldsSwitcher"
import CustomButton from "../../../../ui/atoms/Button"
import { getGraphqlEndpoint } from "../../../../aggregators/rootData/settings"
import axios from "axios"
import Typography from "../../../../ui/atoms/Typography"

const ContactForm = ({ fields, cta, notifications }: ContactFormProps) => {
  const [success, setSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const schema = generateYupSchema(fields)

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema),
  })

  const onSubmit: SubmitHandler<any> = async (data) => {
    setIsLoading(true)
    try {
      const formData = new FormData()

      // Controllo se ci sono file da inviare, avendo due diversi endpoint per questo lavoro
      let hasFile = false

      // Aggiungi tutti i campi del modulo all'oggetto FormData
      Object.entries(data).forEach(([key, value]: [string, any]) => {
        if (value instanceof FileList) {
          hasFile = true
          for (let i = 0; i < value.length; i++) {
            formData.append(key, value[i])
          }
        } else {
          formData.append(key, value)
        }
      })

      // Check per l'endpoint
      let url = getGraphqlEndpoint().split("/graphql")[0]
      if (hasFile) url += "/contact-form/submitWithFile"
      else url += "/contact-form/submit"

      const response = await axios.post(url, formData)

      // Se la chiamata ha avuto successo, mostra un messaggio di successo
      if (response.status === 201) {
        setSuccess(true)
      }
    } catch (error) {
      console.log(error)
      alert("Errore durante l'invio del modulo.")
      window.location.reload()
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <CustomRow spacing justify="center">
      <div className="md:w-4/5">
        <form className="mb-5" onSubmit={handleSubmit(onSubmit)}>
          <div className="md:flex md:flex-wrap">
            {fields.map((field, index) => (
              <ContactFormFieldWrapper size={field.fieldSize} key={index}>
                <ContactFormFieldSwitcher
                  content={field}
                  register={register}
                  errors={errors}
                />
              </ContactFormFieldWrapper>
            ))}
            {/*
             * Per come è strutturato il form, passo i campi nascosti con i riferimenti alle notifiche
             */}
            <input
              type="hidden"
              name="userNotification"
              value={notifications.user}
              ref={register}
            />
            <input
              type="hidden"
              name="internalNotification"
              value={notifications.internal}
              ref={register}
            />
          </div>

          <CustomButton
            className="mt-4 bg-darkGreen"
            type="submit"
            disabled={isLoading}
            fullWidth
          >
            {cta}
          </CustomButton>
        </form>
        {
          // Restituisco un div legato allo state, per far comparire un messaggio di successo
          success && (
            <div className="my-4">
              <Typography variant="subtitle1" color="success" textCenter>
                Grazie per averci contattato. Ti risponderemo al più presto.
              </Typography>
            </div>
          )
        }
      </div>
    </CustomRow>
  )
}

export default ContactForm
